import {getQueryParams} from "@util/api";
import {getCookie, setCookie} from "@util/cookies";

const {
    langCode,
    languageName,
    pageTitle,
    siteUrl
} = GLOBAL;

const {searchUrl} = NAV;

const mediaQuery = window.matchMedia("(max-width: 1080px)")

const updateViewport = (mediaQuery) => {
    const mediaMatches = mediaQuery.matches;
    return mediaMatches
        ? 'mobile'
        : 'desktop'
}

const setSessionIdCookie = () => {
    const queryParameters = getQueryParams(new URL(window.location)?.search);

    // Set a cookie for SID, updating the session ID if it's set or not already
    if (queryParameters?.sid) {
        const sidCookie = queryParameters.sid.replace(/['";]/g, "")
        setCookie('sid', sidCookie)
        return sidCookie;
    }

    return getCookie('sid') || null;
}

export default () => ({
    langCode,
    languageName,
    pageTitle,
    searchUrl,
    sessionId: setSessionIdCookie() || null,
    siteUrl,
    viewport: updateViewport(mediaQuery),
})
